import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { queryUserInfoByToken } from '@/api/myCenter';
export default {
  data: function data() {
    return {
      companyName: '',
      unified: '',
      Name: '',
      personL: '',
      phone: ''
    };
  },
  computed: {
    getUser: function getUser() {
      return JSON.parse(sessionStorage.getItem("user"));
    },
    getSourceType: function getSourceType() {
      return sessionStorage.getItem("sourceType");
    }
  },
  created: function created() {
    var _this = this;

    queryUserInfoByToken().then(function (res) {
      res = _this.paramDecrypt(res);

      if (res.code == 200) {
        _this.companyName = res.data.enterpriseName ? res.data.enterpriseName : '-';
        _this.unified = res.data.organization ? res.data.organization : '-';
        _this.Name = res.data.name ? res.data.name : '-';
        _this.phone = res.data.mobilePhone ? res.data.mobilePhone : '-';
      }
    });
  },
  methods: {}
};